"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.packageInfo = void 0;
exports.packageInfo = {
  name: '@polkadot/x-textdecoder',
  path: typeof __dirname === 'string' ? __dirname : 'auto',
  type: 'cjs',
  version: '12.2.2'
};